import { useState, useRef } from "react";
import Config from "../../Config";


import PlTitle from "../../elements/PlTitle";
import InputPagger from "../../helpers/InputPagger";

import InputTextAlpha from "../../helpers/InputTextAlpha";
import InputCombo from "../../helpers/InputCombo";
import InputLegend from "../../helpers/InputLegend";
import InputComboGrupa from "../../helpers/InputComboGrupaE";

import InputComboRok from "../../helpers/InputComboRok";
import InputComboMiesiac from "../../helpers/InputComboMiesiac";



import Csv from "../../exporter/Csv";
import Print from "../../exporter/Print";
import HtmlToPDF from "../../exporter/HtmlToPDF";

import trash from "../../trash.png";
import gin from "../../gin.png";
import gout from "../../gout.png";
import InOutNewM from "./InOutNewM";


import XTime from "./XTime";
import XTimeByDay from "./XTimeByDay";
import X2Time from "./X2Time";
import InputComboDzien from "../../helpers/InputComboDzien";
import MenuTable from "../../helpers/MenuTable";
import InOutNewVirtual from "./InOutNewVirtual";



function InOutE(props)
{

    //do przemyślenia
    var cData = Config.getFromBuffer(Config.cache_grups_emps,3600, props.userData );
    
    const [gr, setGr] = useState(cData);

    const [refreshView, setRefreshView] = useState(props.userData.refreshView);

    const tabRef = useRef(0);
    const tab2Ref = useRef(0);

    

    const [filter, setFilter] = useState(null);
    const [filterParam, setFilterParam] = useState({
        d_imie_nazwisko: props.mainView.readFilter('d_imie_nazwisko',''),          
        p_grupa_id: props.mainView.readFilter('p_grupa_id','_x_'),
        operacja: '_x_',
        rok: (new Date()).getFullYear() ,
        miesiac: (new Date() ).getMonth()+1,           
        dzien: (new Date() ).getDay(),           
        limit: 50,
        page: 1,
        pages: 1,
    });
    const [tab, setTab] = useState(null);
    const [tabKids, setTabKids] = useState(null);

    const [selectedRow, setSelectedRow] = useState([]);

    const [view, setView] = useState ( {
        v:'list',
        id: -1
    } );



    const [legend, setLegend] = useState([
        {
            cls:'color_show1',
            title: 'Wejście lub wyjście wirtualne - systemowe',
       
        },
    ]);


    const getGr = () => {
       
 
        props.mainView.setProgress(-2);
    
       
    
        fetch( Config.url + '/rest_v1_employessModule,gr', {
            method: 'POST', 
            body: JSON.stringify({}), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 
    
                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        setGr(res.result);      
                        
                        Config.setToBuffer(Config.cache_grups, res.result, props.userData);
                                
                    }
    
            } )
            .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
            });
                   
    
            return false;
    }

    

    

    if( gr == null ||  gr.length == 0 )
    {
            getGr();
            
            return <div></div>;                 
            
    }


        //-------------------------------------------------------
//-------------------------------------------------------
//MASS
const changeSelected = (e) => {

    var id    = e.target.getAttribute('atr-id');   
    var selected = 0;

    if(e.target.checked) selected = 1;

    for(var k=0; k<selectedRow.length; k++)
    {
        if(selectedRow[k].id == id)  selectedRow[k].selected = selected;
    }

    setSelectedRow(  JSON.parse(JSON.stringify(selectedRow) ) );    
}

const changeSelectedAll = (e) => {

    var s = selectedRow[0].selected;
    if(s == 1) {  s = 0; } else s = 1;

    for(var k=0; k<selectedRow.length; k++)
        {
          selectedRow[k].selected = s;
        }
    
        setSelectedRow(  JSON.parse(JSON.stringify(selectedRow) ) ); 

}


//-------------------------------------------------------
//-------------------------------------------------------


const getTab = () => {
       
 
    props.mainView.setProgress(-2);

   

    fetch( Config.url + '/rest_v1_employessModule,kidsE_inout', {
        method: 'POST', 
        body: JSON.stringify(filterParam), 
        headers: {
            'Content-Type': 'application/json',                    
            'X-Api-Key': props.userData.apiKey,
            '_p_przedszkole_id_': props.userData.p_przedszkole_id,
            '_p_dziecko_id_': props.userData.p_dziecko_id,
            '_sec_key_': Config.genXKey() ,
        }
     })
     .then(res => res.json() )
     .then(res => { 

                props.mainView.setProgress(-1);        
                if(res._sys_ == undefined)
                {
                    props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                }else
                if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                {
                    props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                }else    
                {
                    setTab(res.result);            


                    var newSelector = [];

                    res.result.forEach( (item) => {
                        newSelector.push({
                            id: item.id,
                            title: item.imie  + "  " + item.nazwisko,
                            selected: 0,
                        });
                    } )

                    setSelectedRow(newSelector);


                    if(res.pages != undefined )setFilterParam( {...filterParam,   ['pages']: res.pages  } );             
                }
     } )
     .catch(err => {          
                props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                props.mainView.setProgress(-1);
     });
               

     return false;
    }


   
  

    const valChangeListener = (filedName, val, correct, msg) => {

       // console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);

        setFilterParam( {...filterParam, [filedName]:val,  [filedName+"_valid"]:correct } );
        
        var modX = val.length % 3;
        if(  val.length == 0 || modX == 0 || msg =='combo')
        setTab(null);  

        props.mainView.writeFilter(filedName, val);
    }


    const goNextNew = () => {
        //console.log("goNext");    
        setTab(null);    
    }

    const filterClear = () => {
        setFilterParam({
            d_imie_nazwisko: '', 
            
            p_grupa_id: '_x_', 
            operacja: '_x_',
            rok: (new Date()).getFullYear() ,
            miesiac: (new Date() ).getMonth()+1,  
            dzien: (new Date() ).getDate(),            
            limit: 50,
            page: 1,
            pages: 1,
        });
        setTab(null);

        props.mainView.writeFilter('d_imie_nazwisko', '');
      
        props.mainView.writeFilter('p_group_id', '_x_'); 
    }

    const filterApprove = () => {   
        setTab(null)     
    }

    const onChangePagger = (x_limit, x_page) => {

        setFilterParam(  {...filterParam, ["limit"]:x_limit, ["page"]:x_page} );
        setTab(null);
    }


//param1={row.id} param2={row.dzien}  param3='' param4=''
    const onChangeXTime = (hm, param1, param2, param3, param4) =>  {

        //console.log("XTime ", hm, param1, param2, param3, param4);


        props.mainView.setProgress(-2);

       
        var req = {
            p_rejestr_id: param1,
            dzien: param2,
            hm: hm,            
        };


        fetch( Config.url + '/rest_v1_kids,inout_update', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        props.mainView.showDialog( "Sukces",  "Zmiany zostały zapisane" , "ok" , null );
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });


    }

    


    
    if(tab == null)
    {
        setTab([]);
        getTab();
         
    
        return <div>
            ...
        </div>
    }
    
    
        if(refreshView != props.userData.refreshView)
        {         
            setRefreshView( props.userData.refreshView);
            setTab(null);
            setView( {
                v:'list',
                id: -1
            });
        }



    var operacjaItem = [
        {
            v: '_x_',
            title: '- - -'
        },
        {
            v: 'I',
            title: 'Wejście'
        },
        {
            v: 'O',
            title: 'Wyjście'
        },
    ];




    
    var zaznaczonych = 0;
    for(var s=0; s<selectedRow.length; s++)
    {
        if(selectedRow[s].selected == 1) zaznaczonych ++;
    }

   

    var table = '';    
   
    

    var table = '';

    
        table = gr.map( (grupa, ix) => {
        
                        var grupa_dzieci = tab.filter(tab => tab.grupa === grupa.title)
        
                        
        
                        if(grupa.v!='_x_')
        
                        if(filterParam.p_grupa_id=='_x_' || filterParam.p_grupa_id==grupa.v)    
                        {
                            return <div className='mobile_table'>
                            <div className="mobile_th">{grupa.title} ({grupa_dzieci.length})</div>
                                <div className="mobile_tb">
                                {
                                    grupa_dzieci.map( (dziecko, ix2) => {
                                        
                                        dziecko['i']=ix2+1;

                                        return <div >
                                            <InOutNewM userData={props.userData} mainView={props.mainView} dziecko={dziecko} onSuccess={getTab} />       
                                            
                                        </div>
                                    })
                                }    
                                </div>
                            </div>
                        }
                        
                        
        
        })
    


    return (

        <div className="view_content">
            
            

            <div className="table_filter mobile_filters">

                <div className="filter_controll">   
                        <label>Rok: </label>                             
                        <InputComboRok   userData={props.userData}  mainView={props.mainView}  value={filterParam.rok}   valChange={valChangeListener} goNext={goNextNew} name="rok" placeholder={": "}  noempty="1"   />
                </div> 

                <div className="filter_controll">   
                        <label>Miesiąc: </label>                             
                        <InputComboMiesiac   userData={props.userData}  mainView={props.mainView}  value={filterParam.miesiac}   valChange={valChangeListener} goNext={goNextNew} name="miesiac" placeholder={": "}  noempty="1"   />
                </div>

                <div className="filter_controll">   
                        <label>Dzień: </label>                             
                        <InputComboDzien   userData={props.userData}  mainView={props.mainView}  rok={filterParam.rok}  miesiac={filterParam.miesiac}  value={filterParam.dzien}   valChange={valChangeListener} goNext={goNextNew} name="dzien" placeholder={": "}  noempty="0"   />
                </div>

                <div className="filter_controll">   
                        <label>Typ: </label>                             
                        <InputCombo   userData={props.userData}  mainView={props.mainView}  items={operacjaItem} value={filterParam.operacja}   valChange={valChangeListener} goNext={goNextNew} name="operacja" placeholder={": "}  noempty="1"   />
                </div>


                <div className="filter_controll">   
                    <label>Grupa: </label>                             
                    <InputComboGrupa   userData={props.userData}  mainView={props.mainView}  value={filterParam.p_grupa_id}   valChange={valChangeListener} goNext={goNextNew} name="p_grupa_id" placeholder={"Archiwalne: "}   />
                </div> 


                <div className="filter_controll">   
                    <label>Dziecko: </label>                             
                    <InputTextAlpha   userData={props.userData} value={filterParam.d_imie_nazwisko}   valChange={valChangeListener} goNext={goNextNew} name="d_imie_nazwisko" placeholder={"Dziecko: "}   />
                </div>  

           
                <div className="filter_btn">
                                <span className="btn" onClick={filterApprove} >filtruj</span>&nbsp;&nbsp;<span className="btn" onClick={filterClear} >wyczyść</span>
                </div>

            </div>
            
            
            <div className="bg_center">
                {table}
            </div>

                                                       

        </div>
    )
}


export default InOutE;